export default [
    {
        path: '/transaction',
        name: 'transaction',
        component: () =>
            import('@/views/Wallet/WalletTransaction/WalletTransaction'),
    },
    {
        path: '/refund/:id',
        name: 'refund-detail',
        component: () => import('@/views/Wallet/RefundDetail/RefundDetail'),
    },
    {
        path: '/top-up',
        name: 'top-up',
        component: () => import('@/views/Wallet/TopUp/TopUp'),
    },
    {
        path: '/top-up/:id',
        name: 'top-up-detail',
        component: () => import('@/views/Wallet/TopUpDetail/TopUpDetail'),
    },
    {
        path: '/payments',
        name: 'payments',
        component: () => import('@/views/Wallet/Payments/Payments'),
    },
];
